module.exports = __webpack_public_path__ + "img/BANX-alt.87aa0ccc.svg";